"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YEAR_IN_MILLISECONDS = exports.MONTH_IN_MILLISECONDS = exports.WEEK_IN_MILLISECONDS = exports.DAY_IN_MILLISECONDS = exports.HOUR_IN_MILLISECONDS = exports.MINUTE_IN_MILLISECONDS = exports.SECOND_IN_MILLISECONDS = exports.DAY_IN_HOURS = exports.MONTH_IN_SECONDS = exports.WEEK_IN_SECONDS = exports.DAY_IN_SECONDS = exports.HOUR_IN_SECONDS = exports.MINUTE_IN_SECONDS = void 0;
exports.MINUTE_IN_SECONDS = 60;
exports.HOUR_IN_SECONDS = 3600;
exports.DAY_IN_SECONDS = 24 * exports.HOUR_IN_SECONDS;
exports.WEEK_IN_SECONDS = 7 * exports.DAY_IN_SECONDS;
exports.MONTH_IN_SECONDS = 30 * exports.DAY_IN_SECONDS;
exports.DAY_IN_HOURS = 24;
exports.SECOND_IN_MILLISECONDS = 1000;
exports.MINUTE_IN_MILLISECONDS = 60 * 1000;
exports.HOUR_IN_MILLISECONDS = exports.HOUR_IN_SECONDS * 1000;
exports.DAY_IN_MILLISECONDS = exports.DAY_IN_SECONDS * 1000;
exports.WEEK_IN_MILLISECONDS = exports.WEEK_IN_SECONDS * 1000;
exports.MONTH_IN_MILLISECONDS = exports.MONTH_IN_SECONDS * 1000;
exports.YEAR_IN_MILLISECONDS = exports.DAY_IN_MILLISECONDS * 365.2425; // In the Gregorian calendar, a year has on average 365.2425 days.
//# sourceMappingURL=time.js.map